import { render } from "./TodayLectureTeacher.vue?vue&type=template&id=a2a24902&scoped=true"
import script from "./TodayLectureTeacher.vue?vue&type=script&lang=js"
export * from "./TodayLectureTeacher.vue?vue&type=script&lang=js"

import "./TodayLectureTeacher.vue?vue&type=style&index=0&id=a2a24902&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a24902"]])

export default __exports__